import { useEffect } from 'react';
import { API_VERSION } from '../core/redux/store/api/constants';

const principalUrl = '/principal/me';

export const usePingSession = () => {
  useEffect(() => {
    const ping = async () => {
      try {
        const response = await fetch(`${window.location.origin}/${API_VERSION}${principalUrl}`, {
          method: 'GET',
          redirect: 'manual',
        });

        if (response.status === 0) {
          const redirectUrl = new URL(`${window.location.origin}/${API_VERSION}${principalUrl}`);
          window.location.href = redirectUrl.toString();
        }

        if (response.status >= 400) {
          console.warn('Ошибка проверки сессии', response.status);
        }
      } catch (e) {
        console.error('Ошибка проверки сессии:', e);
      }
    };

    ping();
  }, []);
};
